import {
    ArcType,
    Cartesian3,
    Color,
    GeometryInstance,
    Material,
    PolylineGeometry,
    PolylineMaterialAppearance,
    Primitive,
} from 'cesium';
import { transformGeometry } from '../feature-layer/createFeatureCollection';

const getColorRamp = () => {
    const ramp = document.createElement('canvas');
    ramp.width = 1000;
    ramp.height = 2;
    const ctx = ramp.getContext('2d');
    const grd = ctx.createLinearGradient(0, 0, ramp.width, ramp.height);
    grd.addColorStop(0.1, 'rgba(4, 202, 191, 0.2)');
    grd.addColorStop(0.45, 'rgba(4, 202, 191,0.3)');
    grd.addColorStop(0.48, 'rgba(4, 202, 191, 0.8)');
    grd.addColorStop(0.5, 'rgba(218, 183, 4, 0.8)');
    grd.addColorStop(0.52, 'rgba(4, 202, 191, 0.2)');
    grd.addColorStop(1.0, 'rgba(4, 202, 191, 0.2)');
    ctx.fillStyle = grd;
    ctx.fillRect(0,0,ramp.width, ramp.height)
    return ramp.toDataURL();
}

// 着色器编写，跟上方entity的基本一致
let source = `czm_material czm_getMaterial(czm_materialInput materialInput)
  {
     czm_material material = czm_getDefaultMaterial(materialInput);
     vec2 st = materialInput.st;
     vec4 colorImage = texture2D(image, vec2(fract((st.s - speed * czm_frameNumber * 0.001)), st.t));
     material.alpha = colorImage.a;
     material.diffuse = colorImage.rgb;
     return material;
  }`;

export default class RoadLineLayer extends Primitive {
    constructor(option) {
        const {
            width = 2.0,
            speed = 10,
            data,
            show = true,
            id: key,
            name,
            labelField,
            template,
            image,
            layerControl,
            viewOnly,
            unclickable = false,
            cancelPopup
        } = option;

        const instances = data.map(item => {
            let geometry = item.geometry;
            if (item.geometryInfo) {
                geometry = transformGeometry(item.geometryInfo)
            }

            const positions = geometry.coordinates.map(c => [c[0], c[1], c[2] || 0]);

            const polyline = new PolylineGeometry({
                positions: Cartesian3.fromDegreesArrayHeights([...positions.flat(Infinity)]),
                width,
                arcType: ArcType.GEODESIC,
                vertexFormat: PolylineMaterialAppearance.VERTEX_FORMAT, // 顶点属性，默认即可
            });
            return new GeometryInstance({
                geometry: polyline,
                values_: item,
                id: item.id,
            });
        });

        // 材质着色的外观
        const appearance = new PolylineMaterialAppearance({
            material: new Material({
                fabric: {
                    uniforms: {
                        color: Color.fromCssColorString("#000000"),
                        image: image || getColorRamp(),
                        speed: speed,
                    },
                    source,
                },
                translucent: function () {
                    return true;
                },
            }),
        });

        const primitive = new Primitive({
            geometryInstances: instances,
            show: show,
            appearance: appearance,
            asynchronous: false,
        });
        super(primitive);

        // 图层标识
        this.key = key;

        // 图层名称
        this.name = name;

        // 标签字段
        this.labelField = labelField;

        // 模版内容
        this.template = template;

        // 图层控制
        this.layerControl = layerControl;

        // 仅展示
        this.viewOnly = viewOnly;

        // 是否允许触发点击效果
        this.unclickable = unclickable;

        // 取消气泡
        this.cancelPopup = cancelPopup;

        this.data = data;
    }

    set show(value) {
        this.setVisible(value);
    }

    // 获取地图
    getMap() {
        return this.map;
    }

    // 设置图层显示隐藏
    setVisible(visible) {
        super.show = visible; // 将属性传递给父类

        const map = this.getMap && this.getMap();
        if (map) {
            map.layers.emit('visible', this, visible);
        }
    }

    // 根据条件获取图形数据
    getFeatureByFieldValue(field, value) {
        return this.getFeatures().find(v => v[field] === value);
    }

    // 根据条件获取图形数据，用于地图搜索
    getFeaturesBySearch(field, value) {
        return this.getFeatures().filter(v => (v?.[field] || '').indexOf(value) !== -1).map(v => ({
            // ...v,
            label: v?.[field],
            value: v?.id || v?.facilityId || v?.[field],
            // key: this.key,
            feature: { ...v, primitive: this },
        }));
    }

    // 获取图形
    getFeatures() {
        return this.data
    }
}
